import { createApiAction } from 'src/api';

export const FETCH_ACCOUNT_VENDORS_START =
  'account/fetch_account_vendors_start';
export const FETCH_ACCOUNT_VENDORS_SUCCESS =
  'account/fetch_account_vendors_success';
export const FETCH_ACCOUNT_VENDORS_FAILURE =
  'account/fetch_account_vendors_failure';

export const ADD_ACCOUNT_VENDOR_START = 'account/add_account_vendor_start';
export const ADD_ACCOUNT_VENDOR_SUCCESS = 'account/add_account_vendor_success';
export const ADD_ACCOUNT_VENDOR_FAILURE = 'account/add_account_vendor_failure';

export const DELETE_ACCOUNT_VENDOR_START =
  'account/delete_account_vendor_start';
export const DELETE_ACCOUNT_VENDOR_SUCCESS =
  'account/delete_account_vendor_success';
export const DELETE_ACCOUNT_VENDOR_FAILURE =
  'account/delete_account_vendor_failure';

export const fetchAccountVendors = ({ accountId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/vendors/`,
      method: 'GET',
    },
    [
      FETCH_ACCOUNT_VENDORS_START,
      FETCH_ACCOUNT_VENDORS_SUCCESS,
      FETCH_ACCOUNT_VENDORS_FAILURE,
    ]
  );

export const addAccountVendor = ({ accountId, vendorId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/vendors/`,
      method: 'POST',
      body: {
        vendor_id: vendorId,
      },
    },
    [
      ADD_ACCOUNT_VENDOR_START,
      ADD_ACCOUNT_VENDOR_SUCCESS,
      ADD_ACCOUNT_VENDOR_FAILURE,
    ]
  );

export const deleteAccountVendor = ({ accountId, vendorId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/vendors/${vendorId}/`,
      method: 'DELETE',
    },
    [
      DELETE_ACCOUNT_VENDOR_START,
      DELETE_ACCOUNT_VENDOR_SUCCESS,
      DELETE_ACCOUNT_VENDOR_FAILURE,
    ]
  );
